import { ProcedureRecords } from '../context/types';

/**
 * Populate the given Records using the given Reference Records
 * @param records             ProcedureRecords to populate
 * @param referencedRecords   ProcedureRecords to populate from
 */
const populateReferencingRecords = (records: ProcedureRecords, referencedRecords: ProcedureRecords) =>
  // Populate the Records from the given Referenced Records
  Object.keys(referencedRecords).forEach((recordId) => {
    const referencedRecord = referencedRecords[recordId];
    Object.keys(referencedRecord.record).forEach((questionId) => {
      const referencedQuestion = referencedRecord.record[questionId];
      if (records[recordId].record[questionId].answer || !referencedQuestion) {
        return;
      }

      records[recordId].record[questionId].answer = referencedQuestion.answer;
      records[recordId].record[questionId].answer_type = referencedQuestion.answer_type;
    });
  });

export { populateReferencingRecords };
